import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_BASE, API_PATH } from './constants';
import {
  COMPANIES,
  CREATE_COMPANY_RESPONSE,
  DEFAULT_COMPANY,
  DEFAULT_COMPANY_AVAILABLE_PRODUCTS,
  DEFAULT_COMPANY_MANAGERS,
} from './fixtures';

export const companiesHandlers = [
  http.get(`${API_BASE}/${API_PATH}`, () =>
    HttpResponse.json(COMPANIES, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.post(`${API_BASE}/${API_PATH}`, () =>
    HttpResponse.json(CREATE_COMPANY_RESPONSE, {
      status: HTTPStatusCodes.RESOURCE_CREATED,
    }),
  ),
  http.get(`${API_BASE}/${API_PATH}/:id`, () =>
    HttpResponse.json(DEFAULT_COMPANY, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`${API_BASE}/${API_PATH}/:id/available-products`, () =>
    HttpResponse.json(DEFAULT_COMPANY_AVAILABLE_PRODUCTS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`${API_BASE}/${API_PATH}/:id/managers`, () =>
    HttpResponse.json(DEFAULT_COMPANY_MANAGERS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.delete(`${API_BASE}/${API_PATH}/:id/managers/:managerId`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.NO_CONTENT,
      },
    ),
  ),
];
